// jshint module: true

// Enable Edge classNames (is-edge)
let edge = window.navigator.userAgent.indexOf('Edge');

if (edge !== -1) {
  document.body.classList.add('is-edge');

  let version = parseInt(window.navigator.userAgent.substring(edge + 5, window.navigator.userAgent.indexOf('.', edge)), 10);

  if (version) {
    document.body.classList.add('is-edge' + version);
  }
}



// WEBPACK FOOTER //
// ./website/assets/scripts/polyfills/enable-edge-classnames.js